import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatNodeTimeEnum } from '@src/public/utils/format';
import styles from './index.css';
import watermark1 from '../../../assets/watermark1.png';
import watermark2 from '../../../assets/watermark2.png';
import watermark3 from '../../../assets/watermark3.png';
import iconFanzhuan from '../../../assets/fanzhuan.png';
import iconShichui from '../../../assets/shichui.png';

const cx = classNames.bind(styles);

const Item = ({ content }) => {
    const { item, parties } = content;
    const { title, nodeTime, timeType, partyId, milestone, watermark, highlights } = item;

    const isHighLight = highlights === 1;
    const party = parties.find(item => item.id === partyId);
    const partyColor = party.color;

    const watermarkMap = new Map([[1, watermark1], [2, watermark2], [3, watermark3]]);

    const getMilestone = id => {
        switch (id) {
            case 1:
                return <img src={iconFanzhuan} alt="" className={styles.milestone} />;
            case 2:
                return <img src={iconShichui} alt="" className={styles.milestone} />;
            default:
                return null;
        }
    };

    return (
        <div className={styles.item}>
            <div className={styles.left}>
                <div className={styles.pointWrap}>
                    <div
                        className={cx('point', isHighLight ? 'pointHighlight' : 'pointNormal')}
                        style={isHighLight ? { color: partyColor } : { backgroundColor: partyColor }}
                    />
                </div>
                <div className={styles.line} />
            </div>
            <div className={styles.content}>
                <div className={styles.nav}>
                    <div className={styles.time}>{formatNodeTimeEnum(nodeTime, timeType)}</div>
                </div>
                <div className={styles.foldWrap}>
                    <div className={styles.foldWrapTitle}>
                        {getMilestone(milestone)}
                        <span className={styles.foldWrapTitleText}>{title}</span>
                    </div>
                    {watermarkMap.has(watermark) ? (
                        <div className={styles.watermark}>
                            <img src={watermarkMap.get(watermark)} alt="" />
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

Item.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Item);
